import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { UserRoles, IItemApk } from 'types';
import { allApkTypes } from 'appConstants';
import DataController from 'components/DataController/DataController';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { ApkContext, IApkContext } from 'modules/FirmwareAndApp/Apk/Apk/apkState/apkContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemApk;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setApkIDForDeletion } = useContext<IApkContext>(ApkContext);
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	const apkTypeName = allApkTypes.find((el) => el.apkTypeID === data.type)?.apkTypeName || null;
	const isUnAssigned = !data.restaurants.length;

	const containerClasses = classNames(style.container, {
		[style.itemUnAssigned]: isUnAssigned,
	});
	const versionNameRowClasses = classNames(style.versionName, style.row);
	const versionCodeRowClasses = classNames(style.versionCode, style.row);
	const descriptionRowClasses = classNames(style.description, style.row);
	const applicationIdRowClasses = classNames(style.applicationId, style.row);
	const apkTypeRowClasses = classNames(style.apkType, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const handleSetIdForDeletion = () => {
		setApkIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<Text className={versionNameRowClasses} translationKey={data.versionName} withTooltip={true} />
				<Text className={versionCodeRowClasses} translationKey={String(data.versionCode)} withTooltip={true} />
				<Text className={descriptionRowClasses} translationKey={data.description} withTooltip={true} />
				<Text className={applicationIdRowClasses} translationKey={data.applicationId} withTooltip={true} />
				<Text className={apkTypeRowClasses} translationKey={apkTypeName} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickDelete={hasAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={hasAccess ? `/app/tablet-app/edit?apkID=${data.id}` : undefined}
						size="smallBtn"
					/>
				</div>
			</div>
		</div>
	);
};

export default Item;
